var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14L5.33333 10.6666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83916 12.5809C6.3436 12.0143 3.98579 9.65653 3.41918 7.161C3.32949 6.76593 3.28464 6.56844 3.41457 6.24798C3.5445 5.92753 3.70321 5.82837 4.02064 5.63006C4.7382 5.18177 5.51519 5.03925 6.32156 5.11057C7.45303 5.21065 8.01876 5.26069 8.30096 5.11365C8.58323 4.96661 8.77496 4.62278 9.15856 3.93513L9.64443 3.06403C9.9645 2.49019 10.1246 2.20327 10.501 2.06801C10.8775 1.93275 11.104 2.01466 11.5572 2.17847C12.6168 2.56157 13.4386 3.38337 13.8217 4.44299C13.9855 4.89611 14.0674 5.12267 13.9322 5.49913C13.7969 5.8756 13.51 6.03564 12.9361 6.35572L12.045 6.8528C11.3586 7.2356 11.0154 7.42707 10.8684 7.712C10.7214 7.997 10.7748 8.5504 10.8816 9.65727C10.9601 10.4712 10.8248 11.2533 10.3705 11.9798C10.172 12.2972 10.0727 12.4559 9.75236 12.5857C9.43196 12.7155 9.23436 12.6707 8.83916 12.5809Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinAction);
export default __webpack_public_path__ + "static/media/pin-action.fcc7858b07fc3f6ff063a86ef3bf46e9.svg";
export { ForwardRef as ReactComponent };